export const PROJECT_NAME = 'Care App';
export const BASE_URL = 'http://172.104.206.4:5000';
// export const BASE_URL = 'https://moneymagnet.live';
export const API_URL = BASE_URL + '/api';
export const IMG_URL = BASE_URL ;
export const MAP_API_KEY = 'AIzaSyDeBFQhymQMaqj0DcmPTKeyHLoq9_U6Vb0' ;
export const token =  localStorage.getItem("token")
export const COUNTRY_CODE =  'IN'
export const LOCAL_PATH = 'http://localhost:5000'
export const LOCAL_URL = LOCAL_PATH + '/api';